import type { ComponentProps } from 'react';
import type Confetti from 'react-confetti';

import { CanonsPattern } from 'hb-react/frontoffice/components/SuccessConfetti/patterns/CanonsPattern';
import { DefaultPattern } from 'hb-react/frontoffice/components/SuccessConfetti/patterns/DefaultPattern';

interface SuccessConfettiProps {
  pattern?: 'default' | 'canons';
  enabled?: boolean;
  onConfettiComplete?: ComponentProps<typeof Confetti>['onConfettiComplete'];
}

const SuccessConfetti = ({
  pattern = 'default',
  enabled = true,
  onConfettiComplete,
}: SuccessConfettiProps) => {
  if (!enabled) {
    return null;
  }

  if (pattern === 'canons') {
    return <CanonsPattern onConfettiComplete={onConfettiComplete} />;
  }

  return <DefaultPattern onConfettiComplete={onConfettiComplete} />;
};

export default SuccessConfetti;
